export var LocationType;
(function (LocationType) {
    /** Unknown location type. */
    LocationType["UNKNOWN_LOCATION"] = "UNKNOWN_LOCATION";
    /** Event is on-site at a specific physical location. */
    LocationType["VENUE"] = "VENUE";
    /** Event is online, such as a virtual video conference. */
    LocationType["ONLINE"] = "ONLINE";
})(LocationType || (LocationType = {}));
export var SubdivisionSubdivisionType;
(function (SubdivisionSubdivisionType) {
    SubdivisionSubdivisionType["UNKNOWN_SUBDIVISION_TYPE"] = "UNKNOWN_SUBDIVISION_TYPE";
    /** State */
    SubdivisionSubdivisionType["ADMINISTRATIVE_AREA_LEVEL_1"] = "ADMINISTRATIVE_AREA_LEVEL_1";
    /** County */
    SubdivisionSubdivisionType["ADMINISTRATIVE_AREA_LEVEL_2"] = "ADMINISTRATIVE_AREA_LEVEL_2";
    /** City/town */
    SubdivisionSubdivisionType["ADMINISTRATIVE_AREA_LEVEL_3"] = "ADMINISTRATIVE_AREA_LEVEL_3";
    /** Neighborhood/quarter */
    SubdivisionSubdivisionType["ADMINISTRATIVE_AREA_LEVEL_4"] = "ADMINISTRATIVE_AREA_LEVEL_4";
    /** Street/block */
    SubdivisionSubdivisionType["ADMINISTRATIVE_AREA_LEVEL_5"] = "ADMINISTRATIVE_AREA_LEVEL_5";
    /** ADMINISTRATIVE_AREA_LEVEL_0. Indicates the national political entity, and is typically the highest order type returned by the Geocoder. */
    SubdivisionSubdivisionType["COUNTRY"] = "COUNTRY";
})(SubdivisionSubdivisionType || (SubdivisionSubdivisionType = {}));
export var RecurrenceStatusStatus;
(function (RecurrenceStatusStatus) {
    /** Unknown recurrance status. */
    RecurrenceStatusStatus["UNKNOWN_STATUS"] = "UNKNOWN_STATUS";
    /** Event happens only once and can last multiple days. */
    RecurrenceStatusStatus["ONE_TIME"] = "ONE_TIME";
    /** A series of events that repeat. */
    RecurrenceStatusStatus["RECURRING"] = "RECURRING";
    /** Next event in a schedule of recurring events. */
    RecurrenceStatusStatus["RECURRING_UPCOMING"] = "RECURRING_UPCOMING";
    /** Latest event that ended in a schedule of recurring events. */
    RecurrenceStatusStatus["RECURRING_RECENTLY_ENDED"] = "RECURRING_RECENTLY_ENDED";
    /** Latest canceled event in a schedule of recurring events */
    RecurrenceStatusStatus["RECURRING_RECENTLY_CANCELED"] = "RECURRING_RECENTLY_CANCELED";
})(RecurrenceStatusStatus || (RecurrenceStatusStatus = {}));
export var Status;
(function (Status) {
    /** Unknown event status. */
    Status["UNKNOWN_EVENT_STATUS"] = "UNKNOWN_EVENT_STATUS";
    /** Event is published and scheduled to start. */
    Status["UPCOMING"] = "UPCOMING";
    /** Event has started. */
    Status["STARTED"] = "STARTED";
    /** Event has ended. */
    Status["ENDED"] = "ENDED";
    /** Event is canceled. */
    Status["CANCELED"] = "CANCELED";
    /** Event is not public. */
    Status["DRAFT"] = "DRAFT";
})(Status || (Status = {}));
export var RegistrationTypeType;
(function (RegistrationTypeType) {
    /** Unknown registration type. */
    RegistrationTypeType["UNKNOWN_REGISTRATION_TYPE"] = "UNKNOWN_REGISTRATION_TYPE";
    /** Guests register by RSVPing to the event. */
    RegistrationTypeType["RSVP"] = "RSVP";
    /** Guests register by buying tickets. */
    RegistrationTypeType["TICKETING"] = "TICKETING";
    /** Guests register externally using some other site or platform. */
    RegistrationTypeType["EXTERNAL"] = "EXTERNAL";
    /** No registration is required, all guests can attend. This registration type is for only displaying the event details on a site. The property value can be changed from `RSVP` or `TICKETING `to `EXTERNAL` or `NONE` after the event is created, depending on any additional configurations applied to the event. */
    RegistrationTypeType["NONE"] = "NONE";
    /** Guests register by RSVPing to the event or by buying tickets. */
    RegistrationTypeType["RSVP_AND_TICKETING"] = "RSVP_AND_TICKETING";
})(RegistrationTypeType || (RegistrationTypeType = {}));
export var RegistrationStatusStatus;
(function (RegistrationStatusStatus) {
    /** Registration status isn't applicable. */
    RegistrationStatusStatus["UNKNOWN_REGISTRATION_STATUS"] = "UNKNOWN_REGISTRATION_STATUS";
    /** Registration is closed after tickets are sold out. */
    RegistrationStatusStatus["CLOSED_AUTOMATICALLY"] = "CLOSED_AUTOMATICALLY";
    /** Registration is closed when the `registration.registrationDisabled` property is set to `true`. */
    RegistrationStatusStatus["CLOSED_MANUALLY"] = "CLOSED_MANUALLY";
    /** Guests can start RSVPing to the event. */
    RegistrationStatusStatus["OPEN_RSVP"] = "OPEN_RSVP";
    /** Guest list has reached the maximum, new guests are added to a waitlist. */
    RegistrationStatusStatus["OPEN_RSVP_WAITLIST_ONLY"] = "OPEN_RSVP_WAITLIST_ONLY";
    /** Guests can buy tickets to the event. */
    RegistrationStatusStatus["OPEN_TICKETS"] = "OPEN_TICKETS";
    /** Guests register on a different page or web address. */
    RegistrationStatusStatus["OPEN_EXTERNAL"] = "OPEN_EXTERNAL";
    /** Registration via RSVP is scheduled for the future. */
    RegistrationStatusStatus["SCHEDULED_RSVP"] = "SCHEDULED_RSVP";
    /** Guests can RSVP and buy tickets to the event. */
    RegistrationStatusStatus["OPEN_RSVP_AND_TICKETS"] = "OPEN_RSVP_AND_TICKETS";
})(RegistrationStatusStatus || (RegistrationStatusStatus = {}));
export var ResponseType;
(function (ResponseType) {
    /** Unknown response type. */
    ResponseType["UNKNOWN_RESPONSE_TYPE"] = "UNKNOWN_RESPONSE_TYPE";
    /** Only a **Yes** answer is available to select when RSVP'ing to an event. */
    ResponseType["YES_ONLY"] = "YES_ONLY";
    /** *Yes** and **No** answers are available to select when RSVP'ing to an event. */
    ResponseType["YES_AND_NO"] = "YES_AND_NO";
})(ResponseType || (ResponseType = {}));
/** Tax application settings. */
export var TaxType;
(function (TaxType) {
    /** Unknown tax type. */
    TaxType["UNKNOWN_TAX_TYPE"] = "UNKNOWN_TAX_TYPE";
    /** Deduct the fee from the ticket price for a seller. For example, if you're selling tickets for $10, a ticket service fee of $0.25 is deducted from the price and you'll get $9.75. */
    TaxType["INCLUDED_IN_PRICE"] = "INCLUDED_IN_PRICE";
    /** Show the fee in addition to the ticket price at checkout and a guest pays the fee. For example, if you sell tickets for $10, a customer sees a ticket service fee of $0.25 and pays $10.25 in total. */
    TaxType["ADDED_AT_CHECKOUT"] = "ADDED_AT_CHECKOUT";
})(TaxType || (TaxType = {}));
export var CheckoutType;
(function (CheckoutType) {
    CheckoutType["UNKNOWN_CHECKOUT_TYPE"] = "UNKNOWN_CHECKOUT_TYPE";
    /** Checkout using Events App. */
    CheckoutType["EVENTS_APP"] = "EVENTS_APP";
    /** Checkout using Ecomm Platform. */
    CheckoutType["ECOMM_PLATFORM"] = "ECOMM_PLATFORM";
})(CheckoutType || (CheckoutType = {}));
export var GuestTypeType;
(function (GuestTypeType) {
    /** Unknown guest type. */
    GuestTypeType["UNKNOWN_GUEST_TYPE"] = "UNKNOWN_GUEST_TYPE";
    /** All site visitors can RSVP to the event. */
    GuestTypeType["VISITOR_OR_MEMBER"] = "VISITOR_OR_MEMBER";
    /** Only people who have signed up as members of your site are able to RSVP to the event. */
    GuestTypeType["MEMBER"] = "MEMBER";
})(GuestTypeType || (GuestTypeType = {}));
export var InitialRegistrationTypeType;
(function (InitialRegistrationTypeType) {
    /** Unknown initial registration type. */
    InitialRegistrationTypeType["UNKNOWN_INITIAL_REGISTRATION_TYPE"] = "UNKNOWN_INITIAL_REGISTRATION_TYPE";
    /** Guests register by RSVPing to the event. */
    InitialRegistrationTypeType["RSVP"] = "RSVP";
    /** Guests register by buying tickets. This property value never changes. */
    InitialRegistrationTypeType["TICKETING"] = "TICKETING";
    /** Guests register by RSVPing to the event or by buying tickets. */
    InitialRegistrationTypeType["RSVP_AND_TICKETING"] = "RSVP_AND_TICKETING";
})(InitialRegistrationTypeType || (InitialRegistrationTypeType = {}));
export var InputControlType;
(function (InputControlType) {
    /** Single text value field. */
    InputControlType["INPUT"] = "INPUT";
    /** Single text value field with multiple lines. */
    InputControlType["TEXTAREA"] = "TEXTAREA";
    /** Single-choice field with predefined values. */
    InputControlType["DROPDOWN"] = "DROPDOWN";
    /** Single-choice field with predefined values. */
    InputControlType["RADIO"] = "RADIO";
    /** Multiple-choice field with predefined values. */
    InputControlType["CHECKBOX"] = "CHECKBOX";
    /** Fields for entering first and last names. */
    InputControlType["NAME"] = "NAME";
    /** Fields for additional guests and their respective names. */
    InputControlType["GUEST_CONTROL"] = "GUEST_CONTROL";
    /** Single-line address field. */
    InputControlType["ADDRESS_SHORT"] = "ADDRESS_SHORT";
    /** Full address field with multiple lines. */
    InputControlType["ADDRESS_FULL"] = "ADDRESS_FULL";
    /** Fields for entering year, month, and day. */
    InputControlType["DATE"] = "DATE";
})(InputControlType || (InputControlType = {}));
export var ValueType;
(function (ValueType) {
    ValueType["TEXT"] = "TEXT";
    ValueType["NUMBER"] = "NUMBER";
    ValueType["TEXT_ARRAY"] = "TEXT_ARRAY";
    ValueType["DATE_TIME"] = "DATE_TIME";
    ValueType["ADDRESS"] = "ADDRESS";
})(ValueType || (ValueType = {}));
export var ConferenceTypeType;
(function (ConferenceTypeType) {
    /** Default value. This value is unused */
    ConferenceTypeType["UNKNOWN_CONFERENCE_TYPE"] = "UNKNOWN_CONFERENCE_TYPE";
    /** Guests can do some actions during the conference, for example talk, turn on their camera and show their screen. */
    ConferenceTypeType["MEETING"] = "MEETING";
    /** Guests can only watch the conference. */
    ConferenceTypeType["WEBINAR"] = "WEBINAR";
})(ConferenceTypeType || (ConferenceTypeType = {}));
export var Type;
(function (Type) {
    /** Created manually by the user. */
    Type["MANUAL"] = "MANUAL";
    /** Created automatically when publishing recurring events. */
    Type["RECURRING_EVENT"] = "RECURRING_EVENT";
    /** Created automatically and used to store component events. */
    Type["COMPONENT"] = "COMPONENT";
})(Type || (Type = {}));
export var NodeType;
(function (NodeType) {
    NodeType["PARAGRAPH"] = "PARAGRAPH";
    NodeType["TEXT"] = "TEXT";
    NodeType["HEADING"] = "HEADING";
    NodeType["BULLETED_LIST"] = "BULLETED_LIST";
    NodeType["ORDERED_LIST"] = "ORDERED_LIST";
    NodeType["LIST_ITEM"] = "LIST_ITEM";
    NodeType["BLOCKQUOTE"] = "BLOCKQUOTE";
    NodeType["CODE_BLOCK"] = "CODE_BLOCK";
    NodeType["VIDEO"] = "VIDEO";
    NodeType["DIVIDER"] = "DIVIDER";
    NodeType["FILE"] = "FILE";
    NodeType["GALLERY"] = "GALLERY";
    NodeType["GIF"] = "GIF";
    NodeType["HTML"] = "HTML";
    NodeType["IMAGE"] = "IMAGE";
    NodeType["LINK_PREVIEW"] = "LINK_PREVIEW";
    /** @deprecated */
    NodeType["MAP"] = "MAP";
    NodeType["POLL"] = "POLL";
    NodeType["APP_EMBED"] = "APP_EMBED";
    NodeType["BUTTON"] = "BUTTON";
    NodeType["COLLAPSIBLE_LIST"] = "COLLAPSIBLE_LIST";
    NodeType["TABLE"] = "TABLE";
    NodeType["EMBED"] = "EMBED";
    NodeType["COLLAPSIBLE_ITEM"] = "COLLAPSIBLE_ITEM";
    NodeType["COLLAPSIBLE_ITEM_TITLE"] = "COLLAPSIBLE_ITEM_TITLE";
    NodeType["COLLAPSIBLE_ITEM_BODY"] = "COLLAPSIBLE_ITEM_BODY";
    NodeType["TABLE_CELL"] = "TABLE_CELL";
    NodeType["TABLE_ROW"] = "TABLE_ROW";
    NodeType["EXTERNAL"] = "EXTERNAL";
    NodeType["AUDIO"] = "AUDIO";
    NodeType["CAPTION"] = "CAPTION";
    NodeType["LAYOUT"] = "LAYOUT";
    NodeType["LAYOUT_CELL"] = "LAYOUT_CELL";
})(NodeType || (NodeType = {}));
export var WidthType;
(function (WidthType) {
    /** Width matches the content width */
    WidthType["CONTENT"] = "CONTENT";
    /** Small Width */
    WidthType["SMALL"] = "SMALL";
    /** Width will match the original asset width */
    WidthType["ORIGINAL"] = "ORIGINAL";
    /** coast-to-coast display */
    WidthType["FULL_WIDTH"] = "FULL_WIDTH";
})(WidthType || (WidthType = {}));
export var PluginContainerDataAlignment;
(function (PluginContainerDataAlignment) {
    /** Center Alignment */
    PluginContainerDataAlignment["CENTER"] = "CENTER";
    /** Left Alignment */
    PluginContainerDataAlignment["LEFT"] = "LEFT";
    /** Right Alignment */
    PluginContainerDataAlignment["RIGHT"] = "RIGHT";
})(PluginContainerDataAlignment || (PluginContainerDataAlignment = {}));
export var ButtonDataType;
(function (ButtonDataType) {
    /** Regular link button */
    ButtonDataType["LINK"] = "LINK";
    /** Triggers custom action that is defined in plugin configuration by the consumer */
    ButtonDataType["ACTION"] = "ACTION";
})(ButtonDataType || (ButtonDataType = {}));
export var Target;
(function (Target) {
    /** Opens the linked document in the same frame as it was clicked (this is default) */
    Target["SELF"] = "SELF";
    /** Opens the linked document in a new window or tab */
    Target["BLANK"] = "BLANK";
    /** Opens the linked document in the parent frame */
    Target["PARENT"] = "PARENT";
    /** Opens the linked document in the full body of the window */
    Target["TOP"] = "TOP";
})(Target || (Target = {}));
export var TextAlignment;
(function (TextAlignment) {
    /** browser default, eqivalent to `initial` */
    TextAlignment["AUTO"] = "AUTO";
    /** Left align */
    TextAlignment["LEFT"] = "LEFT";
    /** Right align */
    TextAlignment["RIGHT"] = "RIGHT";
    /** Center align */
    TextAlignment["CENTER"] = "CENTER";
    /** Text is spaced to line up its left and right edges to the left and right edges of the line box, except for the last line */
    TextAlignment["JUSTIFY"] = "JUSTIFY";
})(TextAlignment || (TextAlignment = {}));
export var LineStyle;
(function (LineStyle) {
    /** Single Line */
    LineStyle["SINGLE"] = "SINGLE";
    /** Double Line */
    LineStyle["DOUBLE"] = "DOUBLE";
    /** Dashed Line */
    LineStyle["DASHED"] = "DASHED";
    /** Dotted Line */
    LineStyle["DOTTED"] = "DOTTED";
})(LineStyle || (LineStyle = {}));
export var Width;
(function (Width) {
    /** Large line */
    Width["LARGE"] = "LARGE";
    /** Medium line */
    Width["MEDIUM"] = "MEDIUM";
    /** Small line */
    Width["SMALL"] = "SMALL";
})(Width || (Width = {}));
export var Alignment;
(function (Alignment) {
    /** Center alignment */
    Alignment["CENTER"] = "CENTER";
    /** Left alignment */
    Alignment["LEFT"] = "LEFT";
    /** Right alignment */
    Alignment["RIGHT"] = "RIGHT";
})(Alignment || (Alignment = {}));
export var ViewMode;
(function (ViewMode) {
    /** No PDF view */
    ViewMode["NONE"] = "NONE";
    /** Full PDF view */
    ViewMode["FULL"] = "FULL";
    /** Mini PDF view */
    ViewMode["MINI"] = "MINI";
})(ViewMode || (ViewMode = {}));
export var LayoutType;
(function (LayoutType) {
    /** Collage type */
    LayoutType["COLLAGE"] = "COLLAGE";
    /** Masonry type */
    LayoutType["MASONRY"] = "MASONRY";
    /** Grid type */
    LayoutType["GRID"] = "GRID";
    /** Thumbnail type */
    LayoutType["THUMBNAIL"] = "THUMBNAIL";
    /** Slider type */
    LayoutType["SLIDER"] = "SLIDER";
    /** Slideshow type */
    LayoutType["SLIDESHOW"] = "SLIDESHOW";
    /** Panorama type */
    LayoutType["PANORAMA"] = "PANORAMA";
    /** Column type */
    LayoutType["COLUMN"] = "COLUMN";
    /** Magic type */
    LayoutType["MAGIC"] = "MAGIC";
    /** Fullsize images type */
    LayoutType["FULLSIZE"] = "FULLSIZE";
})(LayoutType || (LayoutType = {}));
export var Orientation;
(function (Orientation) {
    /** Rows Orientation */
    Orientation["ROWS"] = "ROWS";
    /** Columns Orientation */
    Orientation["COLUMNS"] = "COLUMNS";
})(Orientation || (Orientation = {}));
export var Crop;
(function (Crop) {
    /** Crop to fill */
    Crop["FILL"] = "FILL";
    /** Crop to fit */
    Crop["FIT"] = "FIT";
})(Crop || (Crop = {}));
export var ThumbnailsAlignment;
(function (ThumbnailsAlignment) {
    /** Top alignment */
    ThumbnailsAlignment["TOP"] = "TOP";
    /** Right alignment */
    ThumbnailsAlignment["RIGHT"] = "RIGHT";
    /** Bottom alignment */
    ThumbnailsAlignment["BOTTOM"] = "BOTTOM";
    /** Left alignment */
    ThumbnailsAlignment["LEFT"] = "LEFT";
    /** No thumbnail */
    ThumbnailsAlignment["NONE"] = "NONE";
})(ThumbnailsAlignment || (ThumbnailsAlignment = {}));
export var GIFType;
(function (GIFType) {
    GIFType["NORMAL"] = "NORMAL";
    GIFType["STICKER"] = "STICKER";
})(GIFType || (GIFType = {}));
export var Source;
(function (Source) {
    Source["HTML"] = "HTML";
    Source["ADSENSE"] = "ADSENSE";
})(Source || (Source = {}));
export var Position;
(function (Position) {
    /** Thumbnail positioned at the start (left in LTR layouts, right in RTL layouts) */
    Position["START"] = "START";
    /** Thumbnail positioned at the end (right in LTR layouts, left in RTL layouts) */
    Position["END"] = "END";
    /** Thumbnail positioned at the top */
    Position["TOP"] = "TOP";
    /** Thumbnail hidden and not displayed */
    Position["HIDDEN"] = "HIDDEN";
})(Position || (Position = {}));
export var MapType;
(function (MapType) {
    /** Roadmap map type */
    MapType["ROADMAP"] = "ROADMAP";
    /** Satellite map type */
    MapType["SATELITE"] = "SATELITE";
    /** Hybrid map type */
    MapType["HYBRID"] = "HYBRID";
    /** Terrain map type */
    MapType["TERRAIN"] = "TERRAIN";
})(MapType || (MapType = {}));
export var ViewRole;
(function (ViewRole) {
    /** Only Poll creator can view the results */
    ViewRole["CREATOR"] = "CREATOR";
    /** Anyone who voted can see the results */
    ViewRole["VOTERS"] = "VOTERS";
    /** Anyone can see the results, even if one didn't vote */
    ViewRole["EVERYONE"] = "EVERYONE";
})(ViewRole || (ViewRole = {}));
export var VoteRole;
(function (VoteRole) {
    /** Logged in member */
    VoteRole["SITE_MEMBERS"] = "SITE_MEMBERS";
    /** Anyone */
    VoteRole["ALL"] = "ALL";
})(VoteRole || (VoteRole = {}));
export var PollLayoutType;
(function (PollLayoutType) {
    /** List */
    PollLayoutType["LIST"] = "LIST";
    /** Grid */
    PollLayoutType["GRID"] = "GRID";
})(PollLayoutType || (PollLayoutType = {}));
export var PollLayoutDirection;
(function (PollLayoutDirection) {
    /** Left-to-right */
    PollLayoutDirection["LTR"] = "LTR";
    /** Right-to-left */
    PollLayoutDirection["RTL"] = "RTL";
})(PollLayoutDirection || (PollLayoutDirection = {}));
export var BackgroundType;
(function (BackgroundType) {
    /** Color background type */
    BackgroundType["COLOR"] = "COLOR";
    /** Image background type */
    BackgroundType["IMAGE"] = "IMAGE";
    /** Gradiant background type */
    BackgroundType["GRADIENT"] = "GRADIENT";
})(BackgroundType || (BackgroundType = {}));
export var DecorationType;
(function (DecorationType) {
    DecorationType["BOLD"] = "BOLD";
    DecorationType["ITALIC"] = "ITALIC";
    DecorationType["UNDERLINE"] = "UNDERLINE";
    DecorationType["SPOILER"] = "SPOILER";
    DecorationType["ANCHOR"] = "ANCHOR";
    DecorationType["MENTION"] = "MENTION";
    DecorationType["LINK"] = "LINK";
    DecorationType["COLOR"] = "COLOR";
    DecorationType["FONT_SIZE"] = "FONT_SIZE";
    DecorationType["EXTERNAL"] = "EXTERNAL";
    DecorationType["STRIKETHROUGH"] = "STRIKETHROUGH";
    DecorationType["SUPERSCRIPT"] = "SUPERSCRIPT";
    DecorationType["SUBSCRIPT"] = "SUBSCRIPT";
})(DecorationType || (DecorationType = {}));
export var FontType;
(function (FontType) {
    FontType["PX"] = "PX";
    FontType["EM"] = "EM";
})(FontType || (FontType = {}));
export var ImageStylesPosition;
(function (ImageStylesPosition) {
    /** Image positioned at the start (left in LTR layouts, right in RTL layouts) */
    ImageStylesPosition["START"] = "START";
    /** Image positioned at the end (right in LTR layouts, left in RTL layouts) */
    ImageStylesPosition["END"] = "END";
    /** Image positioned at the top */
    ImageStylesPosition["TOP"] = "TOP";
})(ImageStylesPosition || (ImageStylesPosition = {}));
export var AspectRatio;
(function (AspectRatio) {
    /** 1:1 aspect ratio */
    AspectRatio["SQUARE"] = "SQUARE";
    /** 16:9 aspect ratio */
    AspectRatio["RECTANGLE"] = "RECTANGLE";
})(AspectRatio || (AspectRatio = {}));
export var Resizing;
(function (Resizing) {
    /** Fill the container, may crop the image */
    Resizing["FILL"] = "FILL";
    /** Fit the image within the container */
    Resizing["FIT"] = "FIT";
})(Resizing || (Resizing = {}));
export var Placement;
(function (Placement) {
    /** Ribbon placed on the image */
    Placement["IMAGE"] = "IMAGE";
    /** Ribbon placed on the product information */
    Placement["PRODUCT_INFO"] = "PRODUCT_INFO";
})(Placement || (Placement = {}));
export var CardStylesType;
(function (CardStylesType) {
    /** Card with visible border and background */
    CardStylesType["CONTAINED"] = "CONTAINED";
    /** Card without visible border */
    CardStylesType["FRAMELESS"] = "FRAMELESS";
})(CardStylesType || (CardStylesType = {}));
export var CardStylesAlignment;
(function (CardStylesAlignment) {
    /** Content aligned to start (left in LTR layouts, right in RTL layouts) */
    CardStylesAlignment["START"] = "START";
    /** Content centered */
    CardStylesAlignment["CENTER"] = "CENTER";
    /** Content aligned to end (right in LTR layouts, left in RTL layouts) */
    CardStylesAlignment["END"] = "END";
})(CardStylesAlignment || (CardStylesAlignment = {}));
export var CardStylesLayout;
(function (CardStylesLayout) {
    /** Elements stacked vertically */
    CardStylesLayout["STACKED"] = "STACKED";
    /** Elements arranged horizontally */
    CardStylesLayout["SIDE_BY_SIDE"] = "SIDE_BY_SIDE";
})(CardStylesLayout || (CardStylesLayout = {}));
export var AppType;
(function (AppType) {
    AppType["PRODUCT"] = "PRODUCT";
    AppType["EVENT"] = "EVENT";
    AppType["BOOKING"] = "BOOKING";
})(AppType || (AppType = {}));
export var InitialExpandedItems;
(function (InitialExpandedItems) {
    /** First item will be expended initally */
    InitialExpandedItems["FIRST"] = "FIRST";
    /** All items will expended initally */
    InitialExpandedItems["ALL"] = "ALL";
    /** All items collapsed initally */
    InitialExpandedItems["NONE"] = "NONE";
})(InitialExpandedItems || (InitialExpandedItems = {}));
export var Direction;
(function (Direction) {
    /** Left-to-right */
    Direction["LTR"] = "LTR";
    /** Right-to-left */
    Direction["RTL"] = "RTL";
})(Direction || (Direction = {}));
export var VerticalAlignment;
(function (VerticalAlignment) {
    /** Top alignment */
    VerticalAlignment["TOP"] = "TOP";
    /** Middle alignment */
    VerticalAlignment["MIDDLE"] = "MIDDLE";
    /** Bottom alignment */
    VerticalAlignment["BOTTOM"] = "BOTTOM";
})(VerticalAlignment || (VerticalAlignment = {}));
/**
 * `NullValue` is a singleton enumeration to represent the null value for the
 * `Value` type union.
 *
 * The JSON representation for `NullValue` is JSON `null`.
 */
export var NullValue;
(function (NullValue) {
    /** Null value. */
    NullValue["NULL_VALUE"] = "NULL_VALUE";
})(NullValue || (NullValue = {}));
export var V3BadgeTypeType;
(function (V3BadgeTypeType) {
    /** Unknown badge type. */
    V3BadgeTypeType["UNKNOWN_BADGE_TYPE"] = "UNKNOWN_BADGE_TYPE";
    /** 1st priority badge type. */
    V3BadgeTypeType["FIRST_PRIORITY"] = "FIRST_PRIORITY";
    /** 2nd priority badge type. */
    V3BadgeTypeType["SECOND_PRIORITY"] = "SECOND_PRIORITY";
    /** 3rd priority badge type. */
    V3BadgeTypeType["THIRD_PRIORITY"] = "THIRD_PRIORITY";
})(V3BadgeTypeType || (V3BadgeTypeType = {}));
export var RequestedFields;
(function (RequestedFields) {
    /** Unknown requested field. */
    RequestedFields["UNKNOWN_REQUESTED_FIELD"] = "UNKNOWN_REQUESTED_FIELD";
    /** Returns `shortDescription`, `mainImage` and `calendarUrls`. */
    RequestedFields["DETAILS"] = "DETAILS";
    /** Returns `description`. */
    RequestedFields["TEXTS"] = "TEXTS";
    /** Returns `registration`. */
    RequestedFields["REGISTRATION"] = "REGISTRATION";
    /** Returns `eventPageUrl`. */
    RequestedFields["URLS"] = "URLS";
    /** Returns `form`. */
    RequestedFields["FORM"] = "FORM";
    /** Returns `summaries`. */
    RequestedFields["DASHBOARD"] = "DASHBOARD";
    /** Returns `feed`. */
    RequestedFields["FEED"] = "FEED";
    /** Returns `onlineConferencing.session`. */
    RequestedFields["ONLINE_CONFERENCING_SESSION"] = "ONLINE_CONFERENCING_SESSION";
    /** Returns `seoSettings`. */
    RequestedFields["SEO_SETTINGS"] = "SEO_SETTINGS";
    /** Returns `agendaSettings`. */
    RequestedFields["AGENDA"] = "AGENDA";
    /** Returns `categories`. */
    RequestedFields["CATEGORIES"] = "CATEGORIES";
    RequestedFields["CUSTOMIZABLE_TICKETS"] = "CUSTOMIZABLE_TICKETS";
    /** Returns badges. When using this fieldset, query or list methods limit can't exceed 100 items. */
    RequestedFields["BADGES"] = "BADGES";
})(RequestedFields || (RequestedFields = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var CommonSortOrder;
(function (CommonSortOrder) {
    CommonSortOrder["ASC"] = "ASC";
    CommonSortOrder["DESC"] = "DESC";
})(CommonSortOrder || (CommonSortOrder = {}));
export var Relation;
(function (Relation) {
    /** User is attending the event. The user RSVP'd with status of `YES` or has ordered tickets. */
    Relation["ATTENDING"] = "ATTENDING";
})(Relation || (Relation = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map